export interface UserData {
  email: string;
  firstFullDay?: Date;
  firstName?: string;
  isEarlyArrival?: boolean;
  lastFullDay?: Date;
  lastName?: string;
  points?: Number;
  emailHash?: string;
  gravatarUrl?: string;

  first_full_day?: Date;
  first_name?: string;
  is_early_arrival?: boolean;
  last_full_day?: Date;
  last_name?: string;
  email_hash?: string;
  gravatar_url?: string;
}

// interface Serializable<T> {
//     deserialize(input: Object): T;
// }

/**
 * User
 */
export class User implements UserData {
  email: string;
  firstFullDay?: Date;
  firstName?: string;
  isEarlyArrival?: boolean;
  lastFullDay?: Date;
  lastName?: string;
  points?: Number;

  emailHash?: string;
  gravatarUrl?: string;

  first_full_day?: Date;
  first_name?: string;
  is_early_arrival?: boolean;
  last_full_day?: Date;
  last_name?: string;

  email_hash?: string;
  gravatar_url?: string;

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts